import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import 'typeface-roboto';
import {theme} from 'proxiponents';
import {MuiThemeProvider} from '@material-ui/core';


export default class BootstrapUtil {

  static  bootstrapEntrypoint (reactComponentMap) {
    this._onReady(() => {
      this._renderReactComponents(reactComponentMap);
    });
  }

  static _onReady(callback) {
    if (document.readyState !== 'loading'){
      callback();
    } else {
      document.addEventListener('DOMContentLoaded', callback);
    }
  }

  static _renderReactComponents(reactComponentMap){
    const allFoundReactComponentDivs = document.getElementsByClassName('react-component');

    for (let currentComponentDiv of allFoundReactComponentDivs) {

      const reactComponentLookup = currentComponentDiv.getAttribute('react-component');
      const SpecificReactComponent = reactComponentMap[reactComponentLookup];
      if (!SpecificReactComponent) {
        console.error(`No react component mapping found for ${reactComponentLookup}`);
        currentComponentDiv.innerHTML = `Yo dawg. You forgot to add "react-component" to your react-component which you should do if you want a React Component inside your react-component div. <br /><br /> You need to add ${reactComponentLookup} to the index.js reactComponentMap.`;
        return;
      }

      const specificBootstrap = eval(currentComponentDiv.getAttribute('bootstrap'));

      ReactDOM.render(
        <MuiThemeProvider theme={theme}><SpecificReactComponent {...specificBootstrap} /></MuiThemeProvider>, currentComponentDiv);
    }
  }
}



